export default __webpack_public_path__ + "static/media/credit-bank-secondary.e2ad3d14.png";